export * from './baThemeRun.directive';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/directives/baThemeRun/index.ts